/*
 * @Author: your name
 * @Date: 2020-07-04 20:09:08
 * @LastEditTime: 2022-02-26 21:44:14
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \the_macao_athletics_web2-f\src\request\api.js
 */

import {get, post } from '@/request/http'
import Qs from 'qs';


/**
 * home页接口 拉取某一年的数据 home.vue
 * @param {某一年} year 
 */
export function pageSetting() {
    return get(`/api/webApi/pageSetting`)
}
/**
 * home页接口 拉取某一年的数据 home.vue
 * @param {某一年} year 
 */
export function GetMatch(year, params) {
    return get(`/api/webApi/${year}/match`, params)
}
/**
 * home页接口 拉取某一年的数据 home.vue
 * @param {某一年} year 
 */
export function GetMatchDetail(year) {
    return get(`/api/webApi/match/${year}`)
}
/**
 * home页接口 拿到轮播图片 home.vue
 *   
 */
export function GetCarouselImg() {
    return get(`/api/webApi/homepage/advertisement`)
}
/**
 * detail页面接口 获取某一天具体数值
 * @param {项目类别ID} id 
 */
export function GetMatchDay(id) {
    return get(`/api/webApi/matchDay/${id}`);
}

/**
 * 获取比赛信息
 * @param {某个比赛} id 
 */
export function GetmatchTables(id) {
    return get(`/api/webApi/match/${id}`)
}

/**
 * 
 * @param {项目类别ID} id 
 */
export function GetArticle(id) {
    return get(`/api/webApi/article/${id}`);
}
/**
 * 
 * @param {项目类别ID} matchItemId 
 */
export function GetMatchItemRoster(matchItemId, params) {
    return get(`/api/webApi/matchItem/${matchItemId}/roster`, params);
}
/**
 * 
 * @param {项目类别ID} matchItemId 
 */
export function GetMatchItemResult(matchItemId, params) {
    return get(`/api/webApi/matchItem/${matchItemId}/result`, params);
}
/**
 * 
 * @param {项目类别ID} matchItemId 
 */
export function GetMatchItemTable(matchItemId, params) {
    return get(`/api/webApi/table/${matchItemId}`, params);
}

/**
 * 首页获取年
 * 
 */
// 
export function GetYears() {
    return get(`/api/webApi/years`);
}


export function GetMatchHeader(matchHeaderId) {
    return get(`api/webApi/matchHeader/${matchHeaderId}`);
}

let times =new Date().getTime()
export function GetDefaultDate() {
    return get(`./js/default_date.js?time=`+times);
}
